<template>
    <div class="hts-layout-default">
        <NuxtPage />
    </div>
</template>

<script setup lang="ts"></script>
